import { getEligibleVariantName } from 'shared/components/ExperimentV2/helpers';

const MULTICOUPON_EXPERIMENT_ID = 'coupon-widget-multicoupon-ab';
const MULTICOUPON_VARIANT = 'multicoupon';

const MULTICOUPON_ENDPOINT_PATHS = [
    '/cartapi/v1/reward/apply',
    '/cartapi/v1/reward/remove',
    '/cartapi/v1/cart/refresh',
    '/cartapi/v1/sample/list',
    '/cartapi/v1/sample/add',
    '/cartapi/v1/sample/remove',
    '/cartapi/v1/item/add',
    '/cartapi/v1/item/add/refresh',
    '/cartapi/v1/item/update',
    '/cartapi/v1/item/remove',
    '/cartapi/v1/item/replace',
    '/cartapi/v1/coupon/apply',
    '/cartapi/v1/coupon/remove',
    '/cartapi/v1/address/add',
    '/cartapi/v1/historyItem/remove',
    '/cartapi/v2/address/add',
    '/offer/api/v1/product/customer/best/offers',
];


export const getMulticouponHeaderForUrl = (url: string): Record<string, string> => {
    const isMulticouponEndpoint = MULTICOUPON_ENDPOINT_PATHS.some((path) => url.includes(path));
    if (!isMulticouponEndpoint) return {};

    const { isEligible, variant } = getEligibleVariantName(MULTICOUPON_EXPERIMENT_ID);
    return isEligible && variant === MULTICOUPON_VARIANT ? { experiment: 'multicoupon:true' } : {};
};
